import { useQuery } from '@tanstack/react-query';
import { ENVIRONMENTS } from '../constants/queryKeys';
import { FetchEnvironmentsApi } from '../types';

const useCachedEnvironments = () =>
  useQuery<FetchEnvironmentsApi>([ENVIRONMENTS], () => Promise.resolve([]), {
    enabled: false,
  });

export default useCachedEnvironments;
